import { Injectable } from "@angular/core";
import { BaseApi } from "./baseService";
import { Dictionary } from "lodash";
import { OrderManagementConfig, UserViewConfig } from "../objects/users/user";
import { RequestOptions } from "@angular/http";
import { BaseResponse } from "../objects/common/baseResponse";
import { Order } from "../objects/orders/order";
import { Component } from "../objects/components/component";

@Injectable()
export class UserViewService extends BaseApi {

    public userView: Dictionary<OrderManagementConfig>;

    public getUserView(): Promise<BaseResponse<Dictionary<OrderManagementConfig>>> {

        return this.get<Dictionary<OrderManagementConfig>>(new RequestOptions({
            url: `user/view`,
        })).then(x => {this.userView = x.Data; return x});
    }

    public modify(config: OrderManagementConfig): Promise<BaseResponse<OrderManagementConfig>> {
        return this.put(new RequestOptions({
            url: `user/view/columns`,
            body: config
        }))
    }

    public updateUserView(config: UserViewConfig): Promise<BaseResponse<UserViewConfig>> {
        return this.put(new RequestOptions({
            url: 'user/view',
            body: config
        }));
    }
}


// WEBPACK FOOTER //
// ./app/services/userViewService.ts